export default __webpack_public_path__ + "static/rightImg-fae9496c0336673c3c859aed9a92bfbf.svg";